import Vue from 'vue'
import Router from 'vue-router'
// Views
import Auth from './views/Auth.vue'
import ChangePassword from './views/ChangePassword.vue'
// Regular Views
import Home from './views/regular/Home.vue'
import Others from './views/regular/Others.vue'
import SelectedOther from './views/regular/SelectedOther.vue'
// Admin Views
import Dashboard from './views/admin/Dashboard.vue'

import Admin from './views/admin/Admin.vue'
import AllInteractions from './views/admin/interactions/All'
import AllStudents from './views/admin/student/All'
import AllCourses from './views/admin/courses/All'
import AllQuestion from './views/admin/questions/All'


import ManageUsers from './views/admin/ManageUsers.vue'
import AllUsers from './views/admin/users/All.vue'
import NewUser from './views/admin/users/New.vue'
import EditUser from './views/admin/users/Edit.vue'

import Grades from './views/admin/interactions/Grades'
import Classrooms from './views/admin/classrooms/Classrooms'
import CourseWork from './views/admin/classrooms/CourseWork'
import Topics from './views/admin/classrooms/Topics'
import Teachers from './views/admin/classrooms/Teachers'
import Students from './views/admin/classrooms/Students'
import WordPressUpload from './views/admin/wordpress/Upload'

import DigitalLiteracy from './views/admin/reports/DigitalLiteracy'
import Performance from './views/admin/reports/Performance'
// Fallbacks
import NotFound from './views/fallbacks/NotFound.vue'
import NotAuthorized from './views/fallbacks/NotAuthorized.vue'
import NotAuthenticated from './views/fallbacks/NotAuthenticated.vue'

// import ConfigureFields from './views/admin/Configure.vue'
//
// import OtherAdmin from './views/admin/Other.vue'


Vue.use(Router);

export default new Router({
  routes: [{
      path: '/',
      name: 'signIn',
      component: Auth,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
        roles: [1]
      }
    },
    {
        path: '/admin',
        component: Admin,
        meta: {
            requiresAuth: true,
            roles: [1, 2, 4]
        },
        children: [
            {
                path: 'courses',
                name: 'allCourses',
                component: AllCourses,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
            {
                path: 'question',
                name: 'allQuestions',
                component: AllQuestion,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
            {
              path: 'interactions',
              name: 'allInteractions',
              component: AllInteractions
            },
            {
              path: '/grades',
              name: 'grades',
              component: Grades,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
            {
              path: '/classrooms',
              name: 'classrooms',
              component: Classrooms,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
            {
              path: '/coursework',
              name: 'courseWork',
              component: CourseWork,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
            {
              path: '/topics',
              name: 'topics',
              component: Topics,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
            {
                path: '/teachers',
                name: 'teachers',
                component: Teachers,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
            {
                path: '/students',
                name: 'students',
                component: Students,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
            {
                path: '/wordpress-upload',
                name: 'wordpress-upload',
                component: WordPressUpload,
                meta: {
                    requiresAuth: true,
                    roles: [1]
                },
            },
        ]
    },
    {
      path: '/others',
      name: 'others',
      component: Others,
      meta: {
        requiresAuth: true,
        roles: [1, 3]
      }
    },
    {
      path: '/others/:id',
      name: 'selectedOther',
      component: SelectedOther,
      meta: {
        requiresAuth: true,
        roles: [1, 3]
      }
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: ChangePassword,
      meta: {
        requiresAuth: true,
        roles: [1, 2, 3, 4]
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        roles: [1, 2, 4]
      }
    },
    {
      path: '/manageUsers',
      component: ManageUsers,
      meta: {
        requiresAuth: true,
        roles: [1]
      },
      children: [
        {
          path: 'all',
          name: 'allUsers',
          component: AllUsers,
            meta: {
                requiresAuth: true,
                roles: [1]
            },
        },
        {
            path: 'students',
            name: 'allStudents',
            component: AllStudents,
            meta: {
                requiresAuth: true,
                roles: [1]
            },
        },
        {
          path: 'new',
          name: 'newUser',
          component: NewUser
        },
        {
          path: ':id/edit',
          name: 'editUser',
          component: EditUser
        },
        {
            path: 'report/digital-literacy',
            name: 'digitalLit',
            component: DigitalLiteracy,
            meta: {
                requiresAuth: true,
                roles: [1]
            },
        },
        {
            path: 'report/performance',
            name: 'performance',
            component: Performance,
            meta: {
                requiresAuth: true,
                roles: [1, 2]
            },
        },
      ]
    },
    {
      path: '/401',
      name: 'notAuthorized',
      component: NotAuthorized,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/403',
      name: 'notAuthenticated',
      component: NotAuthenticated,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/*',
      name: 'catchAll',
      redirect: {
        name: 'notFound'
      },
    }
  ]
})